import { ref } from "vue"
import { ErrorFormat } from "../models/errorFormat"
import { useErrorToaster } from "./toaster"

const unhandledErrors = ref<ErrorFormat[]>([])
setInterval(() => {
	if (unhandledErrors.value.length > 0) {
		const error = unhandledErrors.value.shift()
		if (error) {
			console.error("Developer unhandled exception", error)
			useErrorToaster(error)
		}
	}
}, 3000)

export function useErrorHandler() {
	function addError(error: ErrorFormat) {
		unhandledErrors.value.push(error)
	}

	function setErrorHandled(error: ErrorFormat) {
		const index = unhandledErrors.value.findIndex((e) => e.id === error.id)
		if (index !== -1) {
			unhandledErrors.value.splice(index, 1)
		}
	}

	return {
		unhandledErrors,
		addError,
		setErrorHandled,
	}
}
